import { linkRegex } from './regexp'

export const getHtmlLink = (link: string): string => `<a href="${link}" target="_blank">${link}</a>`

// Split the string to lines by \n, \n\r, \\n, \\n\\r
export const getHtmlString = (value: string): string => value
  .replace(linkRegex, (link) => getHtmlLink(link))
  .replace(/\r|\\r/g, '')
  .replace(/\n|\\n/g, '<br />')
